import { cn } from "@/shared/lib/cn";

/* One row in the sidebar: a main section or a project. Rows are tall and the text full size, so
   the sidebar reads at a glance. The current one sits on a raised surface with a sage bar on its
   start edge and its icon tile in sage. */
const ROW =
  "group/row relative flex h-11 items-center gap-3 rounded-xl px-2 text-[15px] transition-[background-color,color,box-shadow] duration-150";

export const sidebarRowClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    ROW,
    isActive
      ? "bg-surface font-semibold text-ink shadow-sm ring-1 ring-line before:absolute before:inset-y-2.5 before:-start-2 before:w-1 before:rounded-full before:bg-brand"
      : "font-medium text-ink-muted hover:bg-surface-hover hover:text-ink",
  );

/** The square behind a row's icon: sage on the current row, quiet elsewhere. */
export const sidebarIconTileClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "grid size-8 shrink-0 place-items-center rounded-lg transition-colors [&_svg]:size-[19px]",
    isActive
      ? "bg-brand-soft text-brand-strong"
      : "text-ink-subtle group-hover/row:bg-surface group-hover/row:text-ink-muted",
  );
